import React from "react";
import Slider from "react-slick";

import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

const testimonials = [
  {
    id: 1,
    name: "Jane Doe",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    comment:
      "  We collaborate with clients to understand project goals, target audience, and specific features required. We collaborate with clients to understand project goals, target audience, and specific features required.",
    rating: 5,
  },
  {
    id: 2,
    name: "John Smith",
    image: "https://randomuser.me/api/portraits/men/46.jpg",
    comment: "Great experience overall. Would definitely recommend!.",
    rating: 4,
  },
  {
    id: 3,
    name: "Alice Johnson",
    image: "https://randomuser.me/api/portraits/women/65.jpg",
    comment: "Good but there’s room for improvement.",
    rating: 3.5,
  },
];

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`star-${i}`} color="#ffc107" />);
    }

    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" color="#ffc107" />);
    }

    while (stars.length < 5) {
      stars.push(<FaRegStar key={`empty-${stars.length}`} color="#ccc" />);
    }

    return stars;
  };

  return (
    <div className="testimonial-slider">
      <Slider {...settings}>
        {testimonials.map(({ id, name, image, comment, rating }) => (
          <div key={id} className="testimonial-card">
            <div className="testmonial_user ms-auto">
              <img src={image} alt={name} className="user-image" />
            </div>
            <div className="testmonial_details">
              <p className="comment">"{comment}"</p>
              <div className="userating">
                <h5>{name}</h5>
                <div className="stars">{renderStars(rating)}</div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialSlider;
